import { getAuthHeaders } from './utils';


export const fetchParkingSlots = async () => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/parking_slots`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) {
        const error = await res.json();
        throw new Error(error.message || 'Failed to fetch parking slots');
    }
    return res.json(); // { parking_slots: [...] }
};


export const addParkingSlot = async ({ address, slot_number, has_charger }) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/parking_slots/add`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({ address, slot_number, has_charger }),
    });
  
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.message || 'Error adding parking slot');
    }
    return data;
};
  

export const removeParkingSlot = async (slotId) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/parking_slots/remove/${slotId}`, {
      method: 'POST',
      headers: getAuthHeaders(),
    });
    const data = await res.json();
    if (!res.ok) {
      throw new Error(data.message || 'Error removing parking slot');
    }
    return data;
};
  
export const toggleCharger = async (slotId) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/parking_slots/toggle_charger/${slotId}`, {
        method: 'POST',
        headers: getAuthHeaders(),
    });
    const data = await res.json();
    if (!res.ok) {
        throw new Error(data.message || 'Error toggling charger');
    }
    return data;
};
  
export const updateParkingSlotsOrder = async (orderedIds) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/parking_slots/update_order`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ ordered_ids: orderedIds }),
    });
    const data = await res.json();
    if (!res.ok) {
        throw new Error(data.message || 'Error updating slots order');
    }
    return data;
};

export const assignParkingSlot = async (slotId, userIdOrNull) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/parking_slots/assign/${slotId}`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ user_id: userIdOrNull })
    });
    const data = await res.json();
    if (!res.ok) {
        throw new Error(data.message || 'Error assigning slot');
    }
    return data;
};

export const fetchParkingSlotDetails = async (slotId) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/parking_slots/${slotId}/details`, {
        headers: getAuthHeaders(),
    });
    if (!res.ok) {
        const error = await res.json();
        throw new Error(error.message || 'Failed to fetch parking slot details');
    }
    return res.json();
};